/**
 * Read only class. Represents a Stripe Card api object.
 */
class StripeCard {
  /**
   * @property {string} id e.g "card_1HPXSyF21knt8LYb2BLQzgW"
   */
  id;

  /**
   * @property {string} brand e.g "Visa"
   */
  brand;

  /**
   * @property {string} country e.g "US"
   */
  country;

  /**
   * @property {string} customer stripe customer id e.g "cus_HzWWlNPm2iRWB"
   */
  customer;

  /**
   * @property {integer} expMonth e.g 12
   */
  expMonth;

  /**
   * @property {integer} expYear e.g 2023
   */
  expYear;

  /**
   * @property {string} last4 e.g "4242"
   */
  last4;

  /**
   * @property {string} name account holder name on card
   */
  name;

  /**
   * @property {string} label e.g "Visa ***4242 (default)"
   */
  label;

  /**
   * Some keys are expected to be snake case since this is the format returned by Stripe. Note we send the cards result
   * "as is" from the backend after querying Stripe's API. There are more properties but most of them are not
   * of interest.
   */
  constructor({
    id = "",
    brand = "",
    country = "",
    customer = "",
    // eslint-disable-next-line camelcase
    exp_month = "",
    // eslint-disable-next-line camelcase
    exp_year = "",
    last4 = "",
    name = "",
    label = "",
  }) {
    this.id = id;
    this.brand = brand;
    this.country = country;
    this.customer = customer;
    // eslint-disable-next-line camelcase
    this.expMonth = exp_month;
    // eslint-disable-next-line camelcase
    this.expYear = exp_year;
    this.last4 = last4;
    this.name = name;
    this.label = label;
  }
}

export default StripeCard;
